import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { heroTexts, ConactTexts } from '../contexts/LangHero';
import { useLanguage } from '../contexts/LanguageContext';
import Products2 from '../pages/Products2';
import introbatang6Img from '../assets/images/intro-batang6.png';

function HeroSection() {
  const { lang } = useLanguage(); 
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <div style={{ width: '100%', maxWidth: '100vw', overflowX: 'hidden' }}>
      {/* 인트로 화면 */}
      <StartIntro lang={lang} isMobile={isMobile} />
      <Products2 lang={lang} />
      <Contactintro lang={lang}/>
    </div>
  );
}

// 시작 인트로 화면
function StartIntro({ lang, isMobile }) {
  const [scrollY, setScrollY] = useState(0);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const images = [introbatang6Img];

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex(prev => (prev + 1) % images.length);
    }, 7000);
    
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <section
      style={{
        width: '100%',
        maxWidth: '100vw',
        height: '100vh',
        minHeight: '600px',
        background: 'transparent',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      {/* 배경 이미지들 - 2초마다 슬라이드 */}
      {images.map((img, index) => (
        <img
          key={index}
          src={img}
          alt={`intro image ${index + 1}`}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            opacity: index === currentImageIndex ? 1 : 0,
            zIndex: 0,
            pointerEvents: 'none',
            transform: index === currentImageIndex ? 'translateX(0)' : 'translateX(100%)',
            animation: index === currentImageIndex ? 'slideInFromRight 0.8s ease-out' : 'none',
            transition: 'opacity 0.8s ease-out'
          }}
        />
      ))}
      <h1
        style={{
          color: '#ff0000',
          fontSize: isMobile ? '2.4rem' : '3.2rem',
          fontWeight: 800,
          letterSpacing: isMobile ? '-1px' : '-2px',
          margin: 0,
          marginBottom: isMobile ? 16 : 24,
          opacity: 1,
          animation: 'fadeInDown 1.2s',
          zIndex: 1,
          textAlign: 'center',
          padding: isMobile ? '0 20px' : '0'
        }}
      >
        {heroTexts.Herottitle[lang]}
      </h1>
      <p
        style={{
          color: '#28a745',
          fontSize: isMobile ? '1.9rem' : '2.3rem',
          fontWeight: 500,
          marginTop: isMobile ? 40 : 60,
          marginBottom: isMobile ? 40 : 60,
          opacity: 1,
          animation: 'fadeInUp 1.6s',
          zIndex: 1,
          textAlign: 'center',
          padding: isMobile ? '0 20px' : '0'
        }}
      >
        {heroTexts.Heromessage[lang]}
      </p>
      {/* 아래로 스크롤 유도 화살표 */}
      <div
        style={{
          position: 'absolute',
          bottom: isMobile ? 20 : 40,
          left: '50%',
          transform: 'translateX(-50%)',
          opacity: 0.7,
          animation: 'arrowBounce 1.6s infinite',
          zIndex: 1,
          cursor: 'pointer'
        }}
        onClick={() => {
          window.scrollTo({
            top: window.innerHeight,
            behavior: 'smooth'
          });
        }}
        aria-label="제품 인트로로 이동"
      >
        <svg width={isMobile ? "28" : "32"} height={isMobile ? "28" : "32"} viewBox="0 0 32 32">
          <polyline points="8,12 16,20 24,12" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      <style>
        {`
        @keyframes fadeInDown {
          from { opacity: 0; transform: translateY(-40px);}
          to { opacity: 1; transform: translateY(0);}
        }
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(40px);}
          to { opacity: 1; transform: translateY(0);}
        }
        @keyframes arrowBounce {
          0%, 100% { transform: translateX(-50%) translateY(0);}
          50% { transform: translateX(-50%) translateY(16px);}
        }
        @keyframes slideInFromRight {
          0% { transform: translateX(100%); opacity: 0;}
          100% { transform: translateX(0); opacity: 1;}
        }
        `}
      </style>
    </section>
  );
}


// 문의 인트로 화면
function Contactintro({ lang = 'ko' }) {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <section
      style={{
        width: '100%',
        maxWidth: '100vw',
        minHeight: isMobile ? '35vh' : '40vh',
        background: '#D7D9DB',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        padding: isMobile ? '32px 5vw' : '48px 5vw',
        boxSizing: 'border-box'
      }}
    >
      <h2 style={{
        color: '#29225C',
        fontSize: isMobile ? '1.8rem' : '2.2rem',
        fontWeight: 700,
        marginBottom: isMobile ? 12 : 18,
        textAlign: 'center',
        padding: isMobile ? '0 20px' : '0'
      }}>
        {ConactTexts.Contacttitle[lang]}
      </h2>
      <p style={{
        color: '#444',
        fontSize: isMobile ? '1rem' : '1.15rem',
        marginBottom: isMobile ? 24 : 32,
        textAlign: 'center',
        lineHeight: 1.7,
        padding: isMobile ? '0 20px' : '0'
      }}>
        {ConactTexts.Contactmessage[lang]}
      </p>
      <button
        style={{
          padding: isMobile ? '12px 28px' : '14px 36px',
          fontSize: isMobile ? '1rem' : '1.1rem',
          fontWeight: 700,
          color: '#fff',
          background: '#29225C',
          border: 'none',
          borderRadius: 8,
          cursor: 'pointer',
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
          transition: 'background 0.2s'
        }}
        onClick={() => navigate('/contactuse')}
      >
        {ConactTexts.Contactbtn[lang]}
      </button>
    </section>
  );
}

export default HeroSection;